export const primitiveColors = {
  black: '#080E0B',
  gray: '#222627',

  white: '#f8f9fc',

  green_lighter: '#B4E5B6',
  green_light: '#9FEAA4',
  green: '#57C15F',
  green_dark: '#1B2A21',

  red: '#ff4127',
};
